import { Button, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React, { Component } from 'react';
import TnTypography from '../_components/tn-typography/TnTypography';

interface IProps {
  icon: string;
  circledIcon?: string;
  disabledIcon: string;
  label: string;
  classes: any;
  onClick(e: any): void;
  variant?: any;
  className?: any;
  direction?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  borderRequired: boolean;
  isJobDetails?: boolean;
  shortIcon?: boolean;
}

interface IState {}

class LabelledButton extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  render() {
    const { classes, label, onClick, isDisabled, icon, circledIcon, disabledIcon, isJobDetails } = this.props;

    return (
      <Grid container direction="row" justify="center" alignItems="center">
        {label === '' ? (
          // <IconButton
          //     onClick = {onClick}
          //     className={!this.props.shortIcon ? classNames({[classes.button]: true, [classes.disabled]: isDisabled}, this.props.borderRequired && classes.border) : classes.shortIconButton }
          //     disabled={isDisabled}>
          //         { isDisabled ? <img src={disabledIcon} className={!this.props.shortIcon? classes.icon : classes.smallIcon } alt={""}/> : <img src={icon} className={!this.props.shortIcon? classes.icon : classes.smallIcon} alt={""}/>}
          //         {/* { !isJobDetails && <TnTypography variant={this.props.variant || "subtitle2"}
          //                   className={classNames({[classes.label]: true, [classes.disabled]: isDisabled})}>{label}</TnTypography>} */}
          // </IconButton>
          <img src={circledIcon} onClick={onClick} className={classes.circledIcon} />
        ) : (
          <Button
            onClick={onClick}
            className={classNames(
              { [classes.button]: true, [classes.disabled]: isDisabled },
              this.props.borderRequired && classes.border,
            )}
            disabled={isDisabled}
          >
            {isDisabled ? (
              <img src={disabledIcon} className={classes.icon} alt={''} />
            ) : (
              <img src={icon} className={classes.icon} alt={''} />
            )}
            {!isJobDetails && (
              <TnTypography
                variant={this.props.variant || 'subtitle2'}
                className={classNames({
                  [classes.label]: true,
                  [classes.disabled]: isDisabled,
                })}
              >
                {label}
              </TnTypography>
            )}
          </Button>
        )}
      </Grid>
    );
  }
}

export default withStyles((styles) => ({
  button: {
    // minWidth: 50,
    width: 'auto',
    position: 'unset',
  },
  circledIcon: {
    width: 40,
    height: 40,
    cursor: 'pointer',
    [styles.breakpoints.between('xs', 'sm')]: {
      width: '30px',
      height: '30px',
    },
  },
  icon: {
    minWidth: 20,
    minHeight: 20,
    [styles.breakpoints.down(1600)]: {
      minWidth: 'unset',
      minHeight: 'unset',
      width: 16,
      height: 16,
    },
    // width: 20,
    // height: 20
  },
  smallIcon: {
    width: '16px',
    height: '16px',
  },
  disabled: {
    color: '#b3b3b3',
  },
  label: {
    marginLeft: 6,
    fontSize: 14,
    textTransform: 'initial',
  },
  border: {
    // border: "1px solid #1C1E20",
    width: 24,
    height: 24,
    // [styles.breakpoints.down(1600)]:{
    //     minWidth: "unset",
    //     minHeight: "unset",
    //     width: 30,
    //     height: 30,
    //     padding: 0
    // }
  },
  shortIconButton: {
    border: '1px solid #1C1E20',
    width: 30,
    height: 30,
    padding: '0px',
  },
}))(LabelledButton);
